import React from "react";
import { Button, Notification, Table, toaster } from "rsuite";
import axios from "../../../utilities/axios";
import iziToast from "izitoast";

export class CreateLambdaComplement extends React.Component<any, {}> {
  public state = {
    show: false,
    loading: false,
    onSelect: null,
    data: [],
    isLoading: false,
    value: null,
    valueProps: this.props.value,
    isImportModalOmie: false,
    omieData: [],
    OmieItens: [],
    confirmCancelModal: false,
    omieSelectitem: [],
    omieDataSelectDelete: [],
    propsPsm: null,
  };

  componentDidMount = async () => { };

  public select: any = {};

  onChange = (item: any, valuesOmie: any) => { };

  isExecuteQuery = () => {
    let props = this.props.values;
    if (props.development_module_name === "") {
      iziToast.error({
        title: "error!",
        message: "Não foi informado nenhum valor!",
        position: "topRight",
        timeout: 5600,
        close: true,
      });

      return;
    }
    this.setState({
      loading: true,
    });
    axios
      .post("/api/v1/dev/create-lambda", {
        crud: props.development_module_name,
      })
      .then((res) => {
        if (res.data.status === 200) {
          iziToast.success({
            title: "Sucesso!",
            message: res.data.message,
            position: "topRight",
            timeout: 6600,
            close: true,
          });

          setTimeout(this.props.history.go(0), 7000);
        }
        if (res.data.status === 201) {
          iziToast.error({
            title: "Erro!",
            message: res.data.message,
            position: "topRight",
            timeout: 6600,
            close: true,
          });

        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    return (
      <>
        <Button
          color="violet"
          size={"lg"}
          loading={this.state.loading}
          style={{ marginTop: 20, width: "100%" }}
          onClick={() => this.isExecuteQuery()}
        >
          <i className="fal fa-plus-circle"></i> Criar
        </Button>
      </>
    );
  }
}
